module.exports = __webpack_public_path__ + "img/dropdown-menu-solution-4-2.dd2902ea.png";